@let q = question();
<fieldset [formGroup]="form">
  <legend><app-feedback-title [title]="q.title" [subtitle]="q.subtitle" /></legend>
  @for (option of q.options; track option.id) {
    <div class="radio-element">
      <input type="radio" [value]="option.id" [formControlName]="formControlName" id="{{ q.id }}{{ option.id }}" />
      <label for="{{ q.id }}{{ option.id }}">{{ option.label }}</label>
    </div>
  }
  @if (q.wildcard) {
    <div class="radio-element">
      <input
        type="radio"
        [value]="q.wildcard.label + ' ' + additionalInfo()"
        [formControlName]="formControlName"
        [checked]="q.wildcard.label + ' ' + additionalInfo()"
        id="{{ q.title }}{{ q.wildcard.label }}"
      />
      <label for="{{ q.title }}{{ q.wildcard.label }}">{{ q.wildcard.label }}</label>
      <input
        type="text"
        id="{{ q.title }}{{ q.wildcard.label }}: more info"
        placeholder="{{ q.wildcard.placeholder }}"
        class="wildcard-input"
        [value]="additionalInfo()"
        [class.invalid]="controlErrors()?.['emptyWildcard']"
        (input)="updateAdditionalInfo($event)"
      />
      @if (controlErrors()?.["emptyWildcard"]) {
        <div i18n class="error">This field cannot be empty</div>
      }
    </div>
  }
</fieldset>
